export default function addAllEventListeners(selector, type, callback) {
  [].forEach.call(document.querySelectorAll(selector), el => {
    el.addEventListener(type, event => {
      callback(event, event.currentTarget);
    });
  });
}
